'use strict';

class RecipientEdit {
  constructor($scope, $location, $filter, $routeParams, $window, recipientService, commonService, labelService, validationService, userService, originatorService, I18N, Notification, StoreService, reportService) {
    this.$scope = $scope;
    this.$location = $location;
    this.$filter = $filter;
    this.$window = $window;
    this.recipientService = recipientService;
    this.commonService = commonService;
    this.labelService = labelService;
    this.validationService = validationService;
    this.reportService = reportService;
    this.userService = userService;
    this.originatorService = originatorService;
    this.I18N = I18N;
    this.Notification = Notification;


    this.number = $routeParams.number;

    this.availableLabels = new StoreService();
    this.selectedLabels = new StoreService();
  }

  $onInit() {
    this.alert = {};

    this.defaults = null;

    this.autoDunningsDisabled = false;

    this.recipient = {
      number: null,
      customerNumber: null,
      name: null,
      contact: {
        address: {
          address1: null,
          address2: null,
          city: null,
          country: 'NORGE',
          zip: null
        },
        email: null,
        phone: null,
        mobile: null,
        fax: null,
        web: null
      },
      organisation: {
        form: 'prv',
        icd: '9908',
        number: null
      },
      settings: {
        discount: 0,
        creditDays: null,
        defaultShipment: 'EMAIL',
        currency: 'NOK',
        lost: false,
        autoDunningsEnabled: false
      },
      avtaleGiro: {
        kid: null
      },
      yourReference: null,
      defaultEmailCopy: null,
      customFields: [],
      comment: null,
      deleted: false
    };

    this.drafts = {};
    this.invoices = {};
    this.invoicesYears = {};
    this.year = null;
    this.offers = {};
    this.orderConfirmations = {};
    this.templates = {};
    this.newLabel = null;

    // get organisation forms
    this.organisationForms = [];
    this.commonService.getOrganisationForms()
      .then((resp) => {
        this.organisationForms = resp;
      });

    // search by customerNumber
    if (this.$location.search().number) {
      this.recipientService.getBy('customerNumber', this.$location.search().number)
        .then((resp) => this.$location.path(`/kunde/${resp.data.number}`).search('number', null));
    } else if (this.number) {
      this.loadRecipient(this.number);
    } else {
      this.getNextRecipientNumber();
      this.loadCustomFields();
    }

    this.$scope.$on('selectedBrreg', (e, val) => {
      angular.extend(this.recipient, {
        name: val.name,
        organisation: {
          form: val.orgForm,
          number: val.orgNo,
          icd: '9908'
        },
        contact: {
          address: {
            address1: val.address.address1,
            zip: val.address.zip,
            city: val.address.city,
            country: val.address.country
          },
          phone: val.phone,
          mobile: val.mobile
        }
      });
    });
  }

  /**
   * Get the next available customer number
   */
  getNextRecipientNumber() {
    this.recipientService.suggestCustomerNumber()
      .then((resp) => {
        this.recipient.customerNumber = resp.data.customerNumber;
      });
  }

  /**
   * Load draft for the recipient
   *
   * @param {Integer} number Number of the recipient
   */
  loadDrafts(number) {
    this.recipientService.getDrafts(number)
      .then((resp) => {
        this.drafts = resp.data;
      });
  }

  /**
   * Load invoices sent to the recipient
   *
   * @param {Integer} number Number of the recipient
   */
  loadInvoices(number) {
    this.recipientService.getInvoices(number)
      .then((resp) => {
        if (resp.data) {
          this.invoices = resp.data.invoices;
          this.invoicesYears = resp.data.years;

          // assign last active year first
          if (this.year === null && this.invoicesYears && this.invoicesYears.length > 0) {
            this.year = '' + this.invoicesYears[0];
          }

          this.templates = {
            active: [],
            inactive: []
          };

          if (resp.data.templates) {
            resp.data.templates.forEach((t) => {
              if (t.status === 'aktiv') {
                this.templates.active.push(t);
              } else {
                this.templates.inactive.push(t);
              }
            }, this);
          }
        }
      });
  }

  download() {
    this.reportService.invoicePdfForRecipient(this.year, this.recipient.number)
      .then((resp) => {
        if (resp) {
          this.Notification.success(`Rapporten er sendt til ${this.email}`);
        }
      });
  }
  loadOffers(number) {
    this.recipientService.getOffers(number)
      .then((resp) => {
        this.offers = resp.data;
      });
  }

  loadIOrderConfirmations(number) {
    this.recipientService.getOrderConfirmations(number)
      .then((resp) => {
        this.orderConfirmations = resp.data;
      });
  }

  /**
   * Load recipient
   *
   * @param {Integer} number Number of the recipient
   */
  loadRecipient(number) {
    if (number) {
      this.recipientService.get(number)
        .then((json) => json.data)
        .then((resp) => {
          if (resp.settings.currency === '' || resp.settings.currency === null) {
            resp.settings.currency = 'NOK';
          }

          this.autoDunningsDisabled = !resp.settings.autoDunningsEnabled;

          return resp;
        })
        .then((resp) => {
          this.recipient = resp;

          this.loadDrafts(resp.number);
          this.loadInvoices(resp.number);
          this.loadOffers(resp.number);
          this.loadIOrderConfirmations(resp.number);

          if (resp.deleted) {
            this.alert = {
              type: 'warning',
              message: this.I18N.recipient.deleted
            };
          }

          if (this.recipient.lost) {
            this.alert = {
              type: 'warning',
              message: this.I18N.recipient.lost
            };
          }

          this.getLabels();
          this.getRecipientLabels();

          // fix ISO format for DATE fields
          if (resp.customFields && resp.customFields.length) {
            this.recipient.customFields = resp.customFields.map((field) => {
              if (field.type === 'DATE' && field.value !== null && field.value !== '') {
                field.value = moment(field.value, 'YYYY-MM-DD').format('DD.MM.YYYY');
              }

              return field;
            });
          }
        })
        .catch(() => this.$location.path('/kundeliste'));
    }
  }

  getCityByZip() {
    if (this.recipient.contact.address.zip && this.recipient.contact.address.country === 'NORGE') {
      if (this.recipient.contact.address.zip.length === 4) {
        this.commonService.getCityByPostCode(this.recipient.contact.address.zip)
          .then((resp) => {
            this.recipient.contact.address.city = resp.data.city ? resp.data.city : 'OLSO';
          });
      }
    }
  }

  /**
   * Load available labels
   */
  getLabels() {
    this.labelService.list()
      .then((resp) => {
        if (resp.data && resp.status !== 204) {
          resp.data.map((label) => {
            this.availableLabels.add(label);
          });
        }
      });
  }

  /**
   * Load already assigned labels and remove them from the available labels
   */
  getRecipientLabels() {
    if (!this.recipient.deleted) {
      this.recipientService.getLabels(this.recipient.number)
        .then((resp) => {
          if (resp.data && resp.status !== 204) {
            resp.data.map((label) => {
              this.availableLabels.remove(label);
              this.selectedLabels.add(label);
            });
          }
        });
    }
  }

  /**
   * Creates a new label and assign the recipient to it
   */
  addLabel() {
    if (this.newLabel) {
      this.labelService.create(this.newLabel)
        .then((resp) => {
          let number = resp.headers('Location').split('/')[5];

          this.labelService.assignMember(number, this.recipient.number)
            .then(() => {
              this.selectedLabels.add({
                number: number,
                name: this.newLabel
              });

              this.newLabel = null;
            });
        });
    }
  }

  /**
   * Assign a label to the recipient
   *
   * @param {Object} label Label to assign
   */
  selectLabel(label) {
    if (label && label.number) {
      this.labelService.assignMember(label.number, this.recipient.number)
        .then(() => {
          this.availableLabels.remove(label);
          this.selectedLabels.add(label);
        });
    }
  }

  /**
   * Remove a label from the recipient
   *
   * @param {Object} label Label to remove
   */
  deselectLabel(label) {
    if (label && label.number) {
      this.labelService.removeMember(label.number, this.recipient.number)
        .then(() => {
          this.availableLabels.add(label);
          this.selectedLabels.remove(label);
        });
    }
  }

  /**
   * Load custom fields for the recpient
   */
  loadCustomFields() {
    this.recipientService.getCustomFields()
      .then((resp) => {
        this.recipient.customFields = resp.data;
      });
  }

  useBacklink() {
    this.$window.history.back();
  }

  success(resp) {
    let nr = this.recipient.number;

    if (resp.headers('Location') !== null) {
      nr = resp.headers('Location').split('/')[4];
    }

    this.loadRecipient(nr);
    this.Notification.success(this.I18N.general.saved);

    $('.button').removeClass('disabled');

    this.useBacklink();
  }

  save() {
    let recipient = angular.copy(this.recipient);

    $('.alert-box').remove();

    recipient.settings.autoDunningsEnabled = !this.autoDunningsDisabled;

    if (recipient.settings.currency === '') {
      recipient.settings.currency = null;
    }

    if (recipient.settings.defaultShipment === '') {
      recipient.settings.defaultShipment = null;
    }

    if (recipient.organisation.number === '') {
      recipient.organisation.number = null;
    }

    if (recipient.contact.email === '') {
      recipient.contact.email = null;
    }

    // fix ISO format for DATE fields
    if (recipient.customFields) {
      recipient.customFields = this.recipient.customFields.map((field) => {
        if (field.type === 'DATE' && moment(field.value, 'DD.MM.YYYY').isValid()) {
          field.value = moment(field.value, 'DD.MM.YYYY').format('YYYY-MM-DD');
        }

        return field;
      });
    }

    recipient.settings.discount = this.$filter('numberify')(recipient.settings.discount);

    if (recipient.number) {
      this.recipientService.update(recipient.number, recipient)
        .then((resp) => this.success(resp));
    } else {
      this.recipientService.save(recipient)
        .then((resp) => this.success(resp));
    }
  }

  deleteNonInvoiceRecipientData() {
    swal({
      title: 'Bekreft sletting av kunde',
      text: 'Obs! Kundedataene vil ikke kunne gjenopprettes.',
      showCancelButton: true,
      confirmButtonColor: '#970b0e',
      confirmButtonText: 'Ja',
      cancelButtonText: 'Nei',
      closeOnConfirm: false,
      showLoaderOnConfirm: true
    }, (answer) => {
      if (answer) {
        this.recipientService.deleteNonInvoiceRecipientData(this.recipient.number)
          .then(() => {
            swal({
              title: 'Kunden ble slettet OK',
              type: 'success',
              confirmButtonColor: '#004b8d'
            }, () => {});
            this.$location.path('/kundeliste');
          })
          .catch(() => {
            swal.close();
          });
      }
    });
  }

  restore() {
    this.recipientService.restore(this.recipient.number)
      .then(() => {
        this.alert = {};
        this.loadRecipient(this.recipient.number);
      });
  }
}

RecipientEdit.$inject = ['$scope', '$location', '$filter', '$routeParams', '$window', 'recipientService', 'commonService', 'labelService', 'validationService', 'userService', 'originatorService', 'I18N', 'Notification', 'StoreService', 'reportService'];

const recipientEdit = {
  bindings: {
    originator: '<',
    countries: '<',
    currencies: '<'
  },
  controller: RecipientEdit,
  templateUrl: 'recipient/edit.html'
};

angular
  .module('SendRegning')
  .component('recipientEdit', recipientEdit)
  .config(($routeProvider) => {
    $routeProvider
      .when('/kunde', {
        title: 'Vedlikehold av kunder',
        template: '<recipient-edit originator="$resolve.originator" countries="$resolve.countries" currencies="$resolve.currencies" />',
        secure: true,
        resolve: {
          originator: (originatorService) => originatorService.settings().then((resp) => resp.data),
          countries: (commonService) => commonService.getCountries(),
          currencies: (commonService) => commonService.getExchangeRates()
        }
      })
      .when('/kunde/:number', {
        title: 'Vedlikehold av kunder',
        template: '<recipient-edit originator="$resolve.originator" countries="$resolve.countries" currencies="$resolve.currencies" />',
        secure: true,
        resolve: {
          originator: (originatorService) => originatorService.settings().then((resp) => resp.data),
          countries: (commonService) => commonService.getCountries(),
          currencies: (commonService) => commonService.getExchangeRates()
        }
      });
  });
